import { Form, Input, Modal, Select, TreeSelect, message } from "antd";
import { removeVietnameseTones } from "lib/admin";
import _, { debounce, find, get, includes, map, toLower } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import services from "services";

const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;

const CarManageModal = ({
  config,
  _handleToggleModal,
  _handleRefreshTable,
}) => {
  const stationTreeData = useSelector((x) => x.app.listStationsV2);
  const [modalForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [listUser, setListUser] = useState([]);

  const checkSpecialChar = (_, value) => {
    let specials = /[!@#$%^&*()~`]/;
    if (specials.test(value)) {
      return Promise.reject(new Error("Không được nhập kí tự đặc biệt."));
    }
    return Promise.resolve();
  };

  const _handleSave = async () => {
    try {
      const validate = await modalForm.validateFields();
      if (validate.outOfDate) {
        return;
      }
      setLoading(true);
      let { license_plate, username, full_name, department, station } =
        modalForm.getFieldsValue();

      let formData = {
        station_id: station,
        license_plate: license_plate?.trim(),
        username: username?.trim(),
        full_name: full_name?.trim(),
        department: department?.trim(),
        type: "CAR",
      };

      // call api to create
      if (config.isCreate) {
        const response = await services.IOT.addBarrierCar(
          [formData],
          !config.isCreate
        );
        if (!response?.data?.success) {
          message.error(_.get(response, "data.message", "Thêm mới thất bại"));
          return setLoading(false);
        }
        let mess = "Thêm mới thành công";
        message.success(mess);
      } else {
        // call api to update
        const response = await services.IOT.editBarrierCar(
          formData,
          !config.isCreate
        );
        if (!response?.data?.success) {
          message.error(_.get(response, "data.message", "Cập nhật thất bại"));
          return setLoading(false);
        }

        let mess = "Cập nhật thành công";
        message.success(mess);
      }

      // Reload form and table data
      _handleToggleModal({
        visible: false,
        isCreate: false,
        dataSource: {},
      });
      _handleRefreshTable();
      return setLoading(false);
    } catch (error) {}
  };

  let searchUser = debounce(function (value) {
    return services.AdmcsmService.searchUser({ name: value }).then((res) => {
      const isSuccess = get(res, "data.success");
      if (isSuccess) {
        let data = get(res, "data.data", []);
        setListUser(data);
      } else {
        message.error("Có lỗi khi lấy danh sách người dùng");
      }
    });
  }, 500);

  useEffect(() => {
    if (!config.isCreate && config.visible) {
      modalForm.setFieldsValue({
        ["station"]: config.dataSource?.station_id,
        ["license_plate"]: config.dataSource?.license_plate,
        ["username"]: config.dataSource?.username,
        ["full_name"]: config.dataSource?.full_name,
        ["department"]: config.dataSource?.department,
      });
    } else {
      modalForm.setFieldsValue({
        ["station"]: undefined,
        ["license_plate"]: undefined,
        ["username"]: undefined,
        ["full_name"]: undefined,
        ["department"]: undefined,
      });
    }
  }, [modalForm, config]);

  return (
    <Modal
      width={800}
      title={`${config.isCreate ? "Tạo mới" : "Cập nhật"} thông tin xe`}
      centered
      open={config.visible}
      onOk={_handleSave}
      okText={"Lưu"}
      onCancel={() =>
        _handleToggleModal({
          visible: false,
          isCreate: false,
          dataSource: {},
        })
      }
      afterClose={() => {
        modalForm.resetFields();
      }}
      confirmLoading={loading}
    >
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        autoComplete="off"
        layout="horizontal"
        form={modalForm}
        labelAlign={"left"}
      >
        <Form.Item
          name="station"
          label="Kho"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn kho",
            },
          ]}
        >
          <TreeSelect
            disabled={!config.isCreate}
            showSearch
            allowClear
            showCheckedStrategy={SHOW_PARENT}
            style={{ width: "100%" }}
            filterTreeNode={(input, treeNode) => {
              return includes(
                toLower(removeVietnameseTones(get(treeNode, "title"))),
                toLower(removeVietnameseTones(input))
              );
            }}
            dropdownStyle={{
              maxHeight: 400,
              overflow: "auto",
              overflowX: "hidden",
            }}
            placeholder="Chọn kho"
          >
            {map(stationTreeData, (station) => {
              return (
                <TreeNode
                  value={station.region_name}
                  title={station.region_name}
                  key={station.region_name}
                  selectable={false}
                >
                  {map(station.provinces, (province) => {
                    return (
                      <TreeNode
                        value={province.province_name}
                        title={province.province_name}
                        key={province.province_name}
                        selectable={false}
                      >
                        {map(province.stations, (nestStation) => {
                          return (
                            <TreeNode
                              value={nestStation.station_id}
                              title={nestStation.station_name}
                              key={nestStation.station_id}
                            />
                          );
                        })}
                      </TreeNode>
                    );
                  })}
                </TreeNode>
              );
            })}
          </TreeSelect>
        </Form.Item>

        <Form.Item
          label="Biển số"
          name="license_plate"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập biển số xe",
              whitespace: true,
            },
            { validator: checkSpecialChar },
          ]}
        >
          <Input disabled={!config.isCreate} placeholder="Nhập biển số xe" />
        </Form.Item>

        <Form.Item
          name="username"
          label="Username"
          required
          rules={[{ required: true, message: "Vui lòng nhập username" }]}
        >
          <Select
            placeholder="Nhập username"
            showSearch
            allowClear
            className="w-100"
            filterOption={false}
            onSearch={searchUser}
            onSelect={(item) => {
              let user = find(listUser, (x) => x.username === item);
              let full_name;
              if (user) {
                full_name = user?.fullname || "";
              }
              modalForm.setFieldsValue({
                username: item,
                full_name: full_name,
              });
            }}
            options={(listUser || []).map((item) => {
              let label = `User id : ${item?.user_id || "N/a"} - Username : ${
                item?.username
              } - Email : ${item?.primary_email || "N/a"}`;
              return {
                label: label,
                value: item.username,
              };
            })}
          />
        </Form.Item>

        <Form.Item label="Tên đầy đủ" name="full_name">
          <Input placeholder="Nhập tên đầy đủ" />
        </Form.Item>

        <Form.Item
          label="Bộ phận"
          name="department"
          rules={[
            {
              message: "Vui lòng nhập tên bộ phận",
              whitespace: true,
            },
            { validator: checkSpecialChar },
          ]}
        >
          <Input placeholder="Nhập tên bộ phận" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.memo(CarManageModal);
